import type { ReactNode } from 'react';
import { ErrorApi } from '../lib/api.js';

/**
 * Estados de carga, vacio y error.
 *
 * Existen como piezas propias porque son los tres que mas se olvidan, y los
 * tres que el estandar exige: nunca una tabla en blanco sin mensaje, nunca un
 * error crudo, nunca una pantalla que se queda muda mientras carga.
 */

export function Cargando({ que = 'informacion' }: { que?: string }): JSX.Element {
  return (
    <div className="empty" role="status" aria-live="polite">
      <span className="ic" aria-hidden="true">
        ⏳
      </span>
      Cargando {que}…
    </div>
  );
}

export function Vacio({
  mensaje,
  ayuda,
  icono = '📭',
}: {
  mensaje: string;
  ayuda?: string;
  icono?: string;
}): JSX.Element {
  return (
    <div className="empty" data-prueba="vacio">
      <span className="ic" aria-hidden="true">
        {icono}
      </span>
      <div>{mensaje}</div>
      {ayuda && <div style={{ marginTop: 4, fontSize: 12 }}>{ayuda}</div>}
    </div>
  );
}

/**
 * Error con el codigo del catalogo a la vista.
 *
 * El codigo y la traza se muestran a proposito: es lo que la persona reporta
 * y lo que permite encontrar la peticion en la bitacora. Un "algo salio mal"
 * sin identificador convierte cada reporte en una investigacion.
 */
export function Error({ error, children }: { error: unknown; children?: ReactNode }): JSX.Element {
  const api = error instanceof ErrorApi ? error : null;

  return (
    <div className="badbox" role="alert" data-prueba="error">
      <b>{api?.message ?? 'No se pudo completar la operacion'}</b>
      {api && (
        <div className="muted" style={{ marginTop: 4, fontSize: 11.5 }}>
          <span className="folio">{api.codigo}</span>
          {api.trazaId && <> · traza {api.trazaId.slice(0, 8)}</>}
        </div>
      )}
      {api && api.faltan.length > 0 && (
        <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
          {api.faltan.map((f) => (
            <li key={f.campo}>{f.motivo}</li>
          ))}
        </ul>
      )}
      {children}
    </div>
  );
}

export function Toast({ mensaje, malo = false }: { mensaje: string; malo?: boolean }): JSX.Element {
  return (
    <div
      className={malo ? 'toast malo' : 'toast'}
      role="status"
      aria-live="polite"
      data-prueba="toast"
    >
      {mensaje}
    </div>
  );
}
